<div class="source-badge-wrapper" [style.opacity]="opacity">

  <!-- Badge principal: reutiliza la clase .badge global con tooltip de factores -->
  <span class="badge"
        [attr.data-source]="source"
        [appTooltip]="factorsTooltip || null">
    {{ source }}
  </span>

  <!-- Subtipo + icono fantasma (solo si hay v3) -->
  <div class="source-meta" *ngIf="hasV3Data">
    <svg *ngIf="isPhantom" viewBox="0 0 24 24" width="11" height="11"
         class="phantom-icon"
         [appTooltip]="'Tarea preventiva basada en histórico de proyectos análogos'">
      <path fill="currentColor" d="M12 2C8.13 2 5 5.13 5 9c0 1.74.5 3.37 1.41 4.84.95 1.54 2.2 2.86 3.16 4.4.47.75.81 1.45 1.17 2.26.26.55.47 1.5 1.26 1.5s1-.95 1.25-1.5c.37-.81.7-1.51 1.17-2.26.96-1.53 2.21-2.85 3.16-4.4C18.5 12.37 19 10.74 19 9c0-3.87-3.13-7-7-7zm0 9.75c-1.52 0-2.75-1.23-2.75-2.75s1.23-2.75 2.75-2.75 2.75 1.23 2.75 2.75-1.23 2.75-2.75 2.75z"/>
    </svg>
    <span class="subtype-chip" *ngIf="subtype">{{ subtypeLabel }}</span>
  </div>

</div>
